import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/store";
let node = document.getElementById("root");

let root = createRoot(node);

root.render(
  <>
    {/*Make the Provider wrap the whole app*/}
    <Provider store={store}>
      <App />
    </Provider>
  </>
);
